import {
  Lit3formBlock,
  html,
  unsafeHTML,
  classMap,
} from '@Root/lib/lit-3form-block';
import { styles } from './css';

export class Miles extends Lit3formBlock {
  static get characterName() {
    return 'miles';
  }

  static get characterProperties() {
    return {
      headerText: { type: String },
      descriptionText: { type: String },
      imagesArr: { type: String },
    };
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div
          class="${classMap({
            'block-grid': true,
            'miles-layout': true,
            'mobile-rows-1': this.oneRowNeeded,
            'mobile-rows-2': this.twoRowsNeeded,
            'mobile-rows-3': this.threeRowsNeeded,
          })}"
        >
          ${this.headerHTML} ${this.descriptionHTML}
          <div class="images four-per-row">
            ${this.imagesArr.map(i => this.imageHTML(i[1]))}
          </div>
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get headerHTML() {
    return this.headerStr
      ? html`
          <h2>${unsafeHTML(this.headerStr)}</h2>
        `
      : html``;
  }

  get descriptionHTML() {
    return this.descriptionStr
      ? html`
          <p class="description">${unsafeHTML(this.descriptionStr)}</p>
        `
      : html``;
  }

  imageHTML(image) {
    return html`
      <div class="image-wrapper">
        <div class="image">
          <img src=${this.imageUrl(image)} />
          <h3 class="bold">${unsafeHTML(image.header)}</h3>
          <p class="font-size-small">
            ${unsafeHTML(
              this.withLineBreaks(image.subheader || image.description)
            )}
          </p>
        </div>
      </div>
    `;
  }

  imageUrl(img) {
    return this.imagebossUrl(img.src, 320, null);
  }

  get headerStr() {
    return this.withLineBreaks(this.content.header) || '';
  }

  get descriptionStr() {
    return this.withLineBreaks(this.content.description) || '';
  }

  get imagesArr() {
    if (!this.content.images || this.content.images.length === 0) {
      return [];
    }
    return this.content.images;
  }

  get oneRowNeeded() {
    return this.mobileRowsNeeded === 1;
  }

  get twoRowsNeeded() {
    return this.mobileRowsNeeded === 2;
  }

  get threeRowsNeeded() {
    return this.mobileRowsNeeded === 3;
  }

  get mobileRowsNeeded() {
    let count = 0;
    if (!!this.content.header) count++;
    if (!!this.content.description) count++;
    if (!!this.imagesArr.length) count++;
    return count;
  }
}
Miles.defineElement();
